/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { DisplayBurnInRefreshTime_DisplayFragmentDoc } from './DisplayBurnInRefreshTime.graphql';
export type BurnInRefreshSection_DisplayFragment = { __typename: 'Display', id: string, burnInRefreshSettings?: { __typename: 'BurnInRefreshSettingsState', reported: { __typename: 'BurnInRefreshSettings', time: string }, desired?: { __typename: 'BurnInRefreshSettings', time: string } | null } | null };

export const BurnInRefreshSection_DisplayFragmentDoc = gql`
    fragment BurnInRefreshSection_display on Display {
  id
  ...DisplayBurnInRefreshTime_display
}
    ${DisplayBurnInRefreshTime_DisplayFragmentDoc}`;